import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sku-settings-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_form_input, {
      class: "sku-prefix",
      "model-value": _ctx.prefix,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:prefix', $event))),
      disabled: (_ctx.readonly || !_ctx.editing) ? true : undefined,
      onClick: _ctx.enableEditing,
      placeholder: "",
      validator: input => !input || (input.length <= 8 && input.split('').every(i => isNaN(parseInt(i))))
    }, null, 8, ["model-value", "disabled", "onClick", "validator"]),
    _createElementVNode("span", null, _toDisplayString(_ctx.padString(String(_ctx.catalogue.id), _ctx.SKU_PAD_CHAR, _ctx.SKU_CAT_PAD_LENGTH)), 1),
    _createVNode(_component_form_input, {
      class: "sku-separator",
      "model-value": _ctx.separator,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:separator', $event))),
      disabled: (_ctx.readonly || !_ctx.editing) ? true : undefined,
      onClick: _ctx.enableEditing,
      placeholder: "",
      validator: input => !input || (input.length <= 3 && input.split('').every(i => _ctx.ALLOWED_SEPARATORS.includes(i)))
    }, null, 8, ["model-value", "disabled", "onClick", "validator"]),
    _createElementVNode("span", null, _toDisplayString(_ctx.padString('1', _ctx.SKU_PAD_CHAR, _ctx.SKU_ID_PAD_LENGTH)), 1),
    _createVNode(_component_form_input, {
      class: "sku-suffix",
      "model-value": _ctx.suffix,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:suffix', $event))),
      disabled: (_ctx.readonly || !_ctx.editing) ? true : undefined,
      onClick: _ctx.enableEditing,
      validator: input => !input || (input.length <= 8 && input.split('').every(i => isNaN(parseInt(i))))
    }, null, 8, ["model-value", "disabled", "onClick", "validator"])
  ]))
}